import { ReactElement } from "react";
import { Box, Card, SkeletonLoader, Stack } from "@twilio-paste/core";

import styles from "../SearchResults.module.css";

const ResultSkeleton = (): ReactElement => (
  <Card>
    <Box as="div" className={styles.resultSkeletonHeading}>
      <SkeletonLoader height="1.5rem" />
    </Box>

    <Stack orientation="vertical" spacing="space20">
      <SkeletonLoader />
      <SkeletonLoader />
      <SkeletonLoader />
      <SkeletonLoader />
      <SkeletonLoader width="12.5rem" />
    </Stack>

    <Box as="div" className={styles.resultSkeletonFooter}>
      <SkeletonLoader height="1.5rem" />
    </Box>
  </Card>
);

export default ResultSkeleton;
